import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

import Button from '@components/button/Button'

import useBreakpoint from '@utils/useBreakpoints'

interface TitleButton {
  label: string
  onClick: () => void
  status?: ButtonStatus
}

interface Props {
  button?: TitleButton
  title: string
}

const SectionTitle = ({ button, title }: Props) => {
  const [, currentBreakpoint] = useBreakpoint()

  return (
    <Container>
      <Title>{title}</Title>
      <Line />
      {!!button && (
        <ButtonContainer>
          <Button
            status={button.status || 'active'}
            color="light"
            label={button.label}
            onClick={button.onClick}
            textOnly={currentBreakpoint === 'phone'}
          />
        </ButtonContainer>
      )}
    </Container>
  )
}

export default SectionTitle

const Container = styled(View)`
  flex-direction: row;
  align-items: center;
`
const Title = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
`
const Line = styled(View)`
  flex: 1;
  height: ${(props) => (props.theme.breakpoint === 'phone' ? 0 : 1)}px;
  background-color: ${(props) => props.theme.colors.disable};
  margin-left: 16px;
`
const ButtonContainer = styled(View)`
  margin-left: 16px;
  max-width: ${(props) => (props.theme.breakpoint === 'medium' || props.theme.breakpoint === 'small' ? 170 : 300)}px;
`
